import React from "react";
import { CardList } from "@panda0/panda0-ui";
import HeatMap from "@uiw/react-heat-map";
import { BarChart, GitFork, Star } from "lucide-react";

// GitHub Stats Component
const GitHubStats = ({ githubStatsRef, userData, value }) => {
  return (
    <div ref={githubStatsRef} className="pb-10 pt-6 border-t" id="github">
      <div className="flex items-center mb-6">
        <div className="h-8 w-8 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center mr-3">
          <BarChart className="h-4 w-4" />
        </div>
        <h2 className="text-xl font-bold">GitHub Stats</h2>
      </div>

      <CardList.Card outerClassName="border rounded-lg shadow-sm p-4">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-medium">Contribution History</h3>
          <div className="flex items-center">
            <h2 className="text-sm font-semibold mr-2">{userData.login}</h2>
            <a
              href={`https://github.com/${userData.login}`}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full overflow-hidden"
            >
              <img
                src={userData.avatar_url}
                alt={userData.login}
                width={30}
                height={30}
                className="rounded-full"
              />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <HeatMap
              value={value}
              weekLabels={["", "Mon", "", "Wed", "", "Fri", ""]}
              startDate={new Date("2016/01/01")}
              style={{
                width: "100%",
                fontSize: "12px",
                fontWeight: "500",
              }}
              rectSize={10}
            />
            <div className="bg-gray-50 p-3 rounded-md">
              <h4 className="text-sm font-medium mb-1">Top Languages</h4>
              <div className="h-4 w-full rounded-full bg-gray-200 overflow-hidden">
                <div className="flex h-full">
                  <div
                    className="h-full bg-blue-500"
                    style={{ width: "40%" }}
                  ></div>
                  <div
                    className="h-full bg-purple-500"
                    style={{ width: "30%" }}
                  ></div>
                  <div
                    className="h-full bg-green-500"
                    style={{ width: "20%" }}
                  ></div>
                  <div
                    className="h-full bg-yellow-500"
                    style={{ width: "10%" }}
                  ></div>
                </div>
              </div>
              <div className="flex items-center mt-2 text-xs space-x-3">
                <div className="flex items-center">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-1"></span>
                  <span>JavaScript (40%)</span>
                </div>
                <div className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-1"></span>
                  <span>Go (30%)</span>
                </div>
                <div className="flex items-center">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-1"></span>
                  <span>Python (20%)</span>
                </div>
                <div className="flex items-center">
                  <span className="w-2 h-2 bg-yellow-500 rounded-full mr-1"></span>
                  <span>Other (10%)</span>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="text-base font-semibold mb-2">
                Total <span>3</span> Repositories
              </h3>
              <p className="text-sm text-gray-600">
                Sample NodeJS server to handle images in GCP Bucket. Like after
                upload the image will be stored in GCP bucket, So that we can
                access it when we needed.
              </p>

              <div className="flex flex-col mt-3">
                <div className="my-1 flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center">
                      <span className="mr-1 inline-block size-3.5 rounded-full bg-blue-500"></span>
                      <p className="text-sm">NodeJS</p>
                    </div>
                    <div className="flex items-center">
                      <span className="mr-1 inline-block size-3.5 rounded-full bg-green-500"></span>
                      <p className="text-sm">GCP</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="flex items-center">
                      <Star size={14} className="text-yellow-500 mr-1" />
                      <span className="text-xs">12</span>
                    </div>
                    <div className="flex items-center">
                      <GitFork size={14} className="text-gray-500 mr-1" />
                      <span className="text-xs">3</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <p className="text-sm text-gray-600">
                Work-in-progress application to handle sample CRUD operations in
                golang, using postgresql database along with role based access
                feature.
              </p>

              <div className="flex flex-col mt-3">
                <div className="my-1 flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center">
                      <span className="mr-1 inline-block size-3.5 rounded-full bg-blue-500"></span>
                      <p className="text-sm">Golang</p>
                    </div>
                    <div className="flex items-center">
                      <span className="mr-1 inline-block size-3.5 rounded-full bg-purple-500"></span>
                      <p className="text-sm">PostgreSQL</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="flex items-center">
                      <Star size={14} className="text-yellow-500 mr-1" />
                      <span className="text-xs">8</span>
                    </div>
                    <div className="flex items-center">
                      <GitFork size={14} className="text-gray-500 mr-1" />
                      <span className="text-xs">2</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardList.Card>
    </div>
  );
};

export default React.memo(GitHubStats);
